import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";

import { meKey } from "@/app/session/me";
import { ApiError, isApiError } from "@/shared/api/errors";

const MAX_RETRIES = 2;
const HTTP_SERVER_ERROR = 500;

/** Retry only what can succeed on retry: network failures and server errors. */
function shouldRetry(failureCount: number, error: unknown): boolean {
  const clientError =
    error instanceof ApiError && error.status > 0 && error.status < HTTP_SERVER_ERROR;
  return !clientError && failureCount < MAX_RETRIES;
}

export function createQueryClient(): QueryClient {
  /* A refusal means the person's permissions changed under them (someone changed their role),
     so reload them: the screens then hide what they may no longer do. */
  const refreshPermissionsOn = (error: unknown) => {
    if (isApiError(error, "PERMISSION_DENIED")) {
      void queryClient.invalidateQueries({ queryKey: meKey });
    }
  };
  const queryClient: QueryClient = new QueryClient({
    queryCache: new QueryCache({ onError: refreshPermissionsOn }),
    mutationCache: new MutationCache({ onError: refreshPermissionsOn }),
    defaultOptions: {
      queries: { staleTime: 30_000, retry: shouldRetry, refetchOnWindowFocus: true },
      mutations: { retry: false },
    },
  });
  return queryClient;
}
